import Vue from 'vue';
import VueApollo from 'vue-apollo';
import di from 'di';

import { HttpLink } from 'apollo-link-http';
import { onError } from 'apollo-link-error';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';


import fragmentTypes from '../../../fragmentTypes.json';

import authenticationLink from 'js-core/js/apollo/links/authentication';

export default function() {

    const config = di.get('config');

    const httpLink = new HttpLink({
        uri: config.apiUrl + '/graphql'
    });

    const errorLink = onError(({ networkError }) => {

        if(networkError && networkError.statusCode === 401) {

            di.get('auth').logout();
        }
    });

    const link = errorLink.concat(authenticationLink.concat(httpLink));

    const fragmentMatcher = new IntrospectionFragmentMatcher({
        introspectionQueryResultData: fragmentTypes
    });

    const cache = new InMemoryCache({
        fragmentMatcher
    });

    const apolloClient = new ApolloClient({
        link,
        cache
    });


    di.set('apollo', apolloClient);
    Vue.use(VueApollo);
}
